import { Dispatch } from 'redux'
import { ReportGeneratorService } from 'services/reportGenerator.service';
import { decodeBase64ToFile, formatReport, getMimeTypeFromFileName } from 'utils/reportGenerator';

export const setSideBarCollapsed: any = (collapsed: any) => (dispatch: Dispatch) => {
    dispatch({ type: 'SET_SIDEBAR_COLLAPSED', payload: collapsed });
}

export const createReport: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'CREATE_REPORT_STARTED' });
        const res = await ReportGeneratorService.createReport(payload);
        if(!res || (typeof (res.value as any).report_id === 'object' && (res.value as any).report_id.hasOwnProperty('error_code')) ){

            throw new Error('Duplicate Report Name Found');

        }
        dispatch(
            { 
                type: 'CREATE_REPORT_COMPLETED', 
                payload: {  report_id: (res.value as any).report_id, reportName: payload?.report_name, clientName: payload?.client_name, applicationName: payload?.application_name} 
            });
    } catch(e: any) {
        dispatch({ type: 'CREATE_REPORT_ERROR', payload: e?.response?.data === undefined ? {error : e } : e?.response?.data });
    }
}

export const upadateReport: any =
  (payload: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: "UPDATE_REPORT_STARTED" });
      const res = await ReportGeneratorService.updateReport(payload);
      dispatch({
        type: "UPDATE_REPORT_COMPLETED",
        payload: {
          report_id: payload?.report_id,
          reportName: payload?.data?.ReportName,
          clientName: payload?.data?.ClientName,
          applicationName: payload?.data?.ApplicationName,
        },
      });
    } catch (e: any) {
      dispatch({
        type: "UPDATE_REPORT_ERROR",
        payload:
          e?.response?.data === undefined
            ? { error: e }
            : e?.response?.data,
      });
    }
  };
export const resetReportInfo: any = () => (dispatch: Dispatch) => {
    dispatch({ type: 'RESET_REPORT_INFO' });
}

export const backAction: any = () => (dispatch: Dispatch) => {
    dispatch({ type: 'BACK_ACTION' });
}

export const createFinding: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'CREATE_FINDING_STARTED' });
        const res = await ReportGeneratorService.createFinding(payload);
        if(!res) {
            dispatch({ type: 'CREATE_FINDING_ERROR' });
            throw new Error('Error generating create finding');
        }
        dispatch({ type: 'CREATE_FINDING_COMPLETED', payload: res.value });
    } catch(e) {
        dispatch({ type: 'CREATE_FINDING_ERROR' });
    }
}

export const deleteFinding: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'DELETE_FINDING_STARTED' });
        const res = await ReportGeneratorService.deleteFinding(payload);
        if(!res) {
            dispatch({ type: 'DELETE_FINDING_ERROR' });
            throw new Error('Error generating DELETE finding');
        }
        dispatch({ type: 'DELETE_FINDING_COMPLETED', payload: payload });
    } catch(e) {
        dispatch({ type: 'DELETE_FINDING_ERROR' });
    }
}

export const getVulnerabilityCategories: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GET_VUL_CAT_STARTED' });
        const res = await ReportGeneratorService.getVulnerabilityCategories();
        if(!res) {
            dispatch({ type: 'GET_VUL_CAT_ERROR' });
            throw new Error('Error generating get vulnarability categories');
        }
        dispatch({ type: 'GET_VUL_CAT_COMPLETED', payload: (res?.value as any)?.data});
    } catch(e) {
        dispatch({ type: 'GET_VUL_CAT_ERROR' });
    }
}

export const getVulnerabilityName: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GET_VULNAME_STARTED' });
        const res = await ReportGeneratorService.getVulnerabilityName(payload);
        if(!res) {
            dispatch({ type: 'GET_VULNAME_ERROR' });
            throw new Error('Error generating create vulnarability name');
        }
        dispatch({ type: 'GET_VULNAME_COMPLETED', payload: {'vul_category': payload?.vul_category , 'vul_name_list'  :  (res?.value as any)?.data}});
    } catch(e) {
        dispatch({ type: 'GET_VULNAME_ERROR' });
    }
}

export const addVulnerabilityName: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'ADD_VULNAME_STARTED' });
        const res = await ReportGeneratorService.addVulnerabilityName(payload);
        if(!res) {
            dispatch({ type: 'ADD_VULNAME_ERROR' });
            throw new Error('Error generating create vulnarability name');
        }
        dispatch({ type: 'ADD_VULNAME_COMPLETED', payload:{'vul_category' : payload?.vul_category ,'vul_name': payload?.vul_name}});
    } catch(e:any) {
        const errorMsg = e?.response?.data?.message || e?.message || 'Unknown error';
        dispatch({ type: 'ADD_VULNAME_ERROR'})
       throw new Error(errorMsg)
    }
}

export const saveStep: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'ADD_STEP_STARTED' });
        const res = await ReportGeneratorService.saveStep(payload);
        if(!res) {
            dispatch({ type: 'ADD_STEP_ERROR' });
            throw new Error('Error generating step');
        }
        const resultPayload = { 
            ...(typeof res?.value === 'object' && res?.value !== null ? res.value : {}), 
            ...(typeof payload === 'object' && payload !== null ? payload : {}) 
        };
        dispatch({ 
            type: 'ADD_STEP_COMPLETED', 
            payload: resultPayload
        });
        return resultPayload;
    } catch(e) {
        dispatch({ type: 'ADD_STEP_ERROR' });
        throw e;
    }
}

export const updateStepAction: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'UPDATE_STEP_STARTED' });
        const res = await ReportGeneratorService.updateStep(payload);
        if(!res) {
            dispatch({ type: 'UPDATE_STEP_ERROR' });
            throw new Error('Error generating step');
        }
        const mimeTypeUpdate = getMimeTypeFromFileName(payload.data.ImageLabel);
        const fileUpdate = decodeBase64ToFile(payload.data.EncodedImage, payload.data.ImageLabel, mimeTypeUpdate);
        const fileRes = {
            name: fileUpdate.name,
            type: fileUpdate.type,
            size: fileUpdate.size,
            lastModified: fileUpdate.lastModified,
            webkitRelativePath: fileUpdate.webkitRelativePath,
        }
        const updatedStep = {
            encoded_image: payload.data.EncodedImage,
            image_label: payload.data.ImageLabel,
            file: fileRes,
            finding_id: payload.data.FindingId,
            step_id: payload.step_id,
        }
        dispatch({ 
            type: 'UPDATE_STEP_COMPLETED', 
            payload: updatedStep
        });
        return updatedStep;
    } catch(e) {
        dispatch({ type: 'UPDATE_STEP_ERROR' });
    }
}

export const deleteStepAction: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'DELETE_STEP_STARTED' });
        const res = await ReportGeneratorService.deleteStep({step_id: payload.step_id});
        if(!res) {
            dispatch({ type: 'DELETE_STEP_ERROR' });
            throw new Error('Error generating step');
        }
        dispatch({ type: 'DELETE_STEP_COMPLETED', payload });        
    } catch(e) {
        dispatch({ type: 'DELETE_STEP_ERROR' });
    }
}

export const deleteStepUploadImageAction: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'DELETE_STEP_UPLOAD_IMAGE_STARTED' });
        const res = await ReportGeneratorService.deleteStepUploadImage({step_id: payload.step_id});
        if(!res) {
            dispatch({ type: 'DELETE_STEP_UPLOAD_IMAGE_ERROR' });
            throw new Error('Error generating step');
        }
        dispatch({ type: 'DELETE_STEP_UPLOAD_IMAGE_COMPLETED', payload });
    } catch(e) {
        dispatch({ type: 'DELETE_STEP_UPLOAD_IMAGE_ERROR' });
    }
}

export const generateFinding: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GENERATE_FINDING_STARTED' });
        const res = await ReportGeneratorService.generateFinding(payload);
        if(!res) {
            dispatch({ type: 'GENERATE_FINDING_ERROR' });
            throw new Error('Error generating finding');
        }
        dispatch({ 
            type: 'GENERATE_FINDING_COMPLETED', 
            payload: { 
                ...(typeof payload === 'object' ? payload : {}), 
                ...(typeof res.value === 'object' ? res.value : {}) 
            } 
        });
    } catch(e) {
        dispatch({ type: 'GENERATE_FINDING_ERROR' });
        throw new Error('Error generating finding');
    }
}

export const setIsVulNameCategoryChanged: any = (payload: any) => (dispatch: Dispatch) => {
    dispatch({ type: 'SET_IS_VUL_NAME_CATEGORY_CHANGED', payload });
}
export const saveReportWithFinding: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'SAVE_REPORT_STARTED' });
        const res = await ReportGeneratorService.saveReportWithFinding(payload);
        if(!res) {
            dispatch({ type: 'SAVE_REPORT_ERROR' });
            throw new Error('Error generating REPORT');
        }
        dispatch({ type: 'SAVE_REPORT_COMPLETED', payload });
    } catch(e) {
        dispatch({ type: 'SAVE_REPORT_ERROR' });
        throw new Error('Error generating REPORT');
    }
}


export const generateReportWithFinding: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GENERATE_REPORT_STARTED' });
        const res = await ReportGeneratorService.generateReportWithFinding(payload);
        if(!res) {
            dispatch({ type: 'GENERATE_REPORT_ERROR' });
            throw new Error('Error generating REPORT');
        }
        dispatch({ type: 'GENERATE_REPORT_COMPLETED', payload });
        return res;
    } catch(e) {
        dispatch({ type: 'GENERATE_REPORT_ERROR' });
    }
}

export const generateReportWithFindingExcel: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GENERATE_REPORT_STARTED' });
        const res = await ReportGeneratorService.generateReportWithFindingExcel(payload);
        if(!res) {
            dispatch({ type: 'GENERATE_REPORT_ERROR' });
            throw new Error('Error generating REPORT');
        }
        dispatch({ type: 'GENERATE_REPORT_COMPLETED', payload });
        return res;
    } catch(e) {
        dispatch({ type: 'GENERATE_REPORT_ERROR' });
    }
}

export const getReportByID: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'GET_REPORT_BY_ID_STARTED' });
        const res = await ReportGeneratorService.getReportByID(payload);
        if(!res) {
            dispatch({ type: 'GET_REPORT_BY_ID_ERROR' });
            throw new Error('Error generating REPORT');
        }
        const value = res?.value as any[];
        dispatch({
            type: 'GET_REPORT_BY_ID_COMPLETED',
            payload: {
                ...formatReport(value[0], payload?.isAiaTenant),
                reportMode: payload?.mode || (payload?.isLatestVersion === false ? 'view' : 'edit'),
                isLatestVersion: payload?.isLatestVersion !== false,
                versionId: payload?.version_id || undefined,
            }
        });
    } catch(e) {
        dispatch({ type: 'GET_REPORT_BY_ID_ERROR' });
    }
}